<template>
    <div
        class="tile"
        :class="'tile--' + statusKey"
        @click="openSystem()"
    >
        <div class="tile__accent"></div>
        <div class="tile__body">
            <div class="tile__header">
                <span class="tile__name" :title="item.name">{{ item.name }}</span>
                <span class="tile__badge">{{ $t(statusLabel) }}</span>
            </div>
            <div class="tile__columns">
                <div class="tile__column">
                    <span class="tile__label">{{ $t('LastUpdate') }}</span>
                    <div class="tile__value-row">
                        <img class="tile__icon" src="@/assets/img/Dashboard/time_clock_circle.svg" alt="" />
                        <span class="tile__value tile__value--strong">{{ item.lastUpdateFrom }}</span>
                    </div>
                    <span class="tile__label">{{ $t('SystemStatus') }}</span>
                    <div class="tile__value-row">
                        <img class="tile__icon tile__icon--large" src="@/assets/img/Dashboard/operation.svg" alt="" />
                        <span
                            class="tile__value tile__value--strong tile__value--ellipsis"
                            :title="item.statusDescription"
                        >{{ item.statusDescription }}</span>
                    </div>
                </div>
                <div class="tile__column tile__column--narrow">
                    <span class="tile__label">{{ $t('CPUTemperature') }}</span>
                    <span class="tile__value">{{ item.temperature }}°C</span>
                    <span class="tile__label">{{ $t('FreeSpace') }}</span>
                    <span class="tile__value">{{ freeSpaceText }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const STATUS_KEYS = ['ok', 'warning', 'error', 'down']
const STATUS_LABELS = ['Working Fine', 'Warning', 'Error', 'System Down']

export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    computed: {
        statusKey() {
            return STATUS_KEYS[this.item.status] || 'ok'
        },
        statusLabel() {
            return STATUS_LABELS[this.item.status] || STATUS_LABELS[0]
        },
        freeSpaceText() {
            return this.item.freeSpace == null ? '-' : this.item.freeSpace + ' GB'
        }
    },
    methods: {
        openSystem() {
            this.$router.push({
                name: "settingsGeneral",
                params: {
                    systemName: this.item.name,
                    systemId: this.item.id,
                },
            });
        }
    },
}
</script>

<style scoped>
/* Kolory z tokenów --status-* i --dash-* (assets/css/theme.css), więc kafelek
   sam dostosowuje się do motywu jasnego i ciemnego. */
.tile {
    --tile-badge-fg: var(--status-badge-fg);
    display: flex;
    min-height: 118px;
    overflow: hidden;
    border-radius: 6px;
    cursor: pointer;
    background: linear-gradient(100deg, var(--tile-tint) 0%, var(--surface) 75%);
    box-shadow: var(--dash-shadow);
    transition: box-shadow 0.15s ease, transform 0.15s ease;
}

.tile--ok {
    --tile-color: var(--status-ok);
    --tile-tint: var(--status-ok-tint);
}

.tile--warning {
    --tile-color: var(--status-warning);
    --tile-tint: var(--status-warning-tint);
}

.tile--error {
    --tile-color: var(--status-error);
    --tile-tint: var(--status-error-tint);
}

/* Systemy wyłączone mają ciemny akcent — w trybie jasnym na nim biały tekst. */
.tile--down {
    --tile-color: var(--status-down);
    --tile-tint: var(--status-down-tint);
    --tile-badge-fg: var(--status-down-badge-fg);
}

.tile:hover {
    transform: translateY(-2px);
    box-shadow: var(--dash-shadow-hover);
}

.tile__accent {
    width: 7px;
    flex: 0 0 7px;
    background-color: var(--tile-color);
}

.tile__body {
    flex: 1;
    min-width: 0;
    padding: 12px 16px 14px 18px;
}

.tile__header {
    display: flex;
    align-items: center;
    gap: 8px;
}

.tile__name {
    flex: 1;
    min-width: 0;
    font-size: 20px;
    font-weight: bold;
    color: var(--dash-text);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.tile__badge {
    flex: 0 0 auto;
    padding: 2px 8px;
    border-radius: 10px;
    background-color: var(--tile-color);
    color: var(--tile-badge-fg);
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    white-space: nowrap;
}

.tile__columns {
    display: flex;
    gap: 16px;
    margin-top: 8px;
}

.tile__column {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
}

.tile__column--narrow {
    flex: 0 0 90px;
    text-align: right;
}

.tile__label {
    font-size: 10px;
    color: var(--dash-muted);
    margin-top: 4px;
}

.tile__value {
    font-size: 14px;
    color: var(--dash-text);
    min-width: 0;
}

.tile__value--strong {
    font-weight: bold;
}

.tile__value--ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.tile__value-row {
    display: flex;
    align-items: center;
    gap: 4px;
    min-width: 0;
}

.tile__icon {
    filter: var(--dash-icon-filter);
}

.tile__icon--large {
    height: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/DashboardTile.vue